import { defineComponent as _defineComponent } from 'vue'
import { dir } from '@@/bits/current_dir'
import type { HomePageWallFormatCardProps } from '@@/bits/landside_helper'
import { HomePageCard, homepageCards } from '@@/bits/landside_helper'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { useWindowSizeStore } from '@@/pinia/window_size'
import { onMounted, ref, watch } from 'vue'
import HomePageCareersCard from '@@/vuecomponents/HomePageCareersCard.vue'
import HomePageWallFormatCard from '@@/vuecomponents/HomePageWallFormatCard.vue'
import HomePageWelcomeCard from '@@/vuecomponents/HomePageWelcomeCard.vue'
import HomePageWorldwideUsersCard from '@@/vuecomponents/HomePageWorldwideUsersCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideHomePage',
  setup(__props) {

const { isDarkMode } = storeToRefs(useDarkModeStore())
const { windowWidth, isSmallerThanTabletPortrait, isSmallerThanDesktop } = storeToRefs(useWindowSizeStore())

const containerRef = ref<HTMLElement>()
const cardWidth = ref(0)

watch(windowWidth, calculateCardWidth)

onMounted(calculateCardWidth)

function calculateCardWidth(): void {
  const container = containerRef.value
  if (!container) return
  // Every card has the same width and height except the first card, so we can just use the second one
  cardWidth.value = container?.children[1].clientWidth
}

const cards = [
  HomePageCard.FoodBlog,
  HomePageCard.Map,
  HomePageCard.KanbanBoard,
  HomePageCard.Timeline,
  HomePageCard.Portfolio,
  HomePageCard.WorldwideUsers,
  HomePageCard.OrgChart,
  HomePageCard.Presentation,
  HomePageCard.QAndA,
  HomePageCard.PhotoAlbum,
  HomePageCard.VideoPlaylist,
  HomePageCard.FileSharing,
  HomePageCard.NewsFeed,
].map((cardType) => ({
  type: cardType,
  ...homepageCards[cardType],
})) as Array<HomePageWallFormatCardProps & { type: HomePageCard }>

const shouldFlipImage = (cardType: HomePageCard) => {
  return [HomePageCard.Map, HomePageCard.Presentation].includes(cardType) && dir === 'rtl'
}

const shouldLazyLoadImage = (cardType: HomePageCard) => {
  return [
    HomePageCard.PhotoAlbum,
    HomePageCard.VideoPlaylist,
    HomePageCard.FileSharing,
    HomePageCard.NewsFeed,
  ].includes(cardType)
}

return { __sfc: true,isDarkMode, windowWidth, isSmallerThanTabletPortrait, isSmallerThanDesktop, containerRef, cardWidth, calculateCardWidth, cards, shouldFlipImage, shouldLazyLoadImage, HomePageCard, HomePageCareersCard, HomePageWallFormatCard, HomePageWelcomeCard, HomePageWorldwideUsersCard }
}

})